import Openable from '../lib/openable';

class Drawer extends Openable {
  constructor(element, overlay) {
    super(element, overlay);

    this.closeTriggers = element.querySelectorAll('[data-close]');

    this.classes = {
      active: 'drawer--active',
    };

    this.closeTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });
  }
}

export default (element, overlay) => new Drawer(element, overlay);